import { useAbsUrl } from 'hooks/useAbsUrl'
import { NextSeo } from 'next-seo'
import { ComponentType } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  property: any
}

export const Seo: ComponentType<Props> = ({ property }) => {
  const { formatMessage } = useIntl()
  const url = useAbsUrl()

  const values = {
    role: formatMessage({ id: property.role }),
    category: property.category.name,
    zone: property.zone.name,
    uuid: property.uuid,
  }

  const title = property.seoTitle || formatMessage({ id: 'property.head.title' }, values)

  const description = property.seoDescription || formatMessage({ id: 'property.head.description' })

  const keywords = property.seoTags?.join(',')

  const images = [
    {
      url: property.cover.secureUrl,
      width: 800,
      height: 600,
      alt: property.cover.title,
    },
  ]

  const additionalMetaTags = [{
    property: 'keywords',
    content: keywords || ['Yucatan Premier', 'Casas', 'Renta', 'Venta']
  }]

  return <NextSeo title={title} description={description} additionalMetaTags={additionalMetaTags} openGraph={{ title, description, url, images }} />
}
